import { Component, Input } from "@angular/core";
import { DecisionExportLockType } from "src/app/enum";

@Component({
  selector: "locked-info",
  templateUrl: "./locked-info.component.html",
  styleUrls: ["./locked-info.component.scss"]
})
export class LockedInfoComponent {
  @Input()
  public name: string;

  @Input() public locked: IUserLocked;

  public get lockedBy(): { id: string; name: string; email: string } {
    return this.locked?.lockedBy;
  }

  public get lockedAt(): Date {
    return this.locked?.lockedAt;
  }
}

export interface IUserLocked {
  lockedAt: Date;
  lockedBy: {
    id: string;
    name: string;
    email: string;
  };
  decisionId?: string;
  lockType?: DecisionExportLockType;
}